import script from "./ds-segmented-picker-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./ds-segmented-picker-item.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__